var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "loginRoot" }, [
    _c("div", { staticClass: "loginPanel" }, [
      _c("div", { staticClass: "systemName" }, [
        _vm._v(_vm._s(_vm.systemName))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.user,
            expression: "user"
          }
        ],
        staticClass: "txtUser",
        attrs: {
          type: "text",
          placeholder: "User Name",
          autocomplete: "username"
        },
        domProps: { value: _vm.user },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.UserNameEnter($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.user = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.pass,
            expression: "pass"
          }
        ],
        ref: "passwordField",
        staticClass: "txtPass",
        attrs: {
          type: "password",
          placeholder: "Password",
          autocomplete: "current-password"
        },
        domProps: { value: _vm.pass },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.TryLogin($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.pass = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        staticClass: "btnLogin",
        attrs: { type: "button", value: "Log in", disabled: _vm.loggingIn },
        on: {
          click: _vm.TryLogin,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "space", 32, $event.key, [
                " ",
                "Spacebar"
              ]) &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.TryLogin($event)
          }
        }
      }),
      _vm._v(" "),
      _vm.emailConfigured
        ? _c(
            "div",
            { staticClass: "forgotPwLinkWrapper" },
            [
              _c(
                "router-link",
                {
                  staticClass: "forgotPwLink",
                  attrs: { to: _vm.forgotPwRoute }
                },
                [_vm._v("Forgot Password?")]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.error
      ? _c("div", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }